export default __webpack_public_path__ + "static/media/2076_00.da056f82.jpg";